import apiClient from "./axiosConfig";

export const getCFSFields = async () =>
    apiClient.templatesAPI.get(`/api/v1/templates/cfs-fields`);

export const createTemplate = async (request) =>
    apiClient.templatesAPI.post(`/api/v1/templates`, request);

export const updateTemplate = async (request) =>
    apiClient.templatesAPI.put(`/api/v1/templates`, request);

export const getTemplates = async () =>
    apiClient.templatesAPI.get(`/api/v1/templates`);

export const reArrangeTemplates = async (request) =>
    apiClient.templatesAPI.put(`/api/v1/templates/rearrange`, request);

export const getDocusignTemplateReports = async (request) =>
    apiClient.templatesAPI.post(`/api/v1/templates/report`, request);
